"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importStar(require("react"));
const react_hanger_1 = require("react-hanger");
const context_1 = require("../../context");
const react_2 = require("@osmosys/react");
const AdminOnly_1 = require("../reusables/AdminOnly");
const CenteredRow_1 = require("../reusables/CenteredRow");
const ReloadButton_1 = require("./ReloadButton");
exports.OsmosysIsOutOfDateToast = () => {
    const context = react_1.useContext(context_1.OsmosysAppContext);
    const { state: { initialVersion, newVersion }, setState, } = react_hanger_1.useSetState({
        initialVersion: null,
        newVersion: null,
    });
    react_1.useEffect(() => {
        if (context.appSettings) {
            if (!initialVersion) {
                setState({
                    initialVersion: context.appSettings.version,
                });
            }
            else if (initialVersion !== context.appSettings.version) {
                setState({
                    newVersion: context.appSettings.version,
                });
            }
        }
    }, [context.appSettings, initialVersion, setState]);
    const appHasUpdate = initialVersion && newVersion;
    // const [cachedPrevVer, setCachedPrevVer] = useState<false | string>(false);
    // const [appHasUpdate, toggleAppHasUpdate] = useToggle(false);
    // useEffect(() => {
    //   // if (ver && prevVer && prevVer !== ver) {
    //   //   setCachedPrevVer(prevVer);
    //   // }
    //   // 'There is a new version of Osmosys available! Please refresh the app as soon as possible to avoid errors.';
    // }, [
    //   // cachedPrevVer,
    //   prevVer,
    //   context.appSettings && context.appSettings.version,
    // ]);
    const debug = false;
    // useEffect(() => {
    //   if (
    //     !appHasUpdate &&
    //     prevContext &&
    //     prevContext.appSettings &&
    //     context.appSettings &&
    //     prevContext.appSettings.version !== context.appSettings.version
    //   ) {
    //     toggleAppHasUpdate(true);
    //   }
    // }, [context.appSettings]);
    if (appHasUpdate) {
        return (react_1.default.createElement(react_2.OsmosysToast, { iconPreset: "bell", isOpen: true, title: "New version of Osmosys is available!", delay: 1000 },
            react_1.default.createElement(CenteredRow_1.CenteredRow, null,
                "[ (",
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", { className: "mb-0" },
                        "Please refresh to update as soon as possible. ",
                        context.adminRole),
                    react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                        react_1.default.createElement(react_2.OsmosysTooltip, { label: "test" },
                            react_1.default.createElement(CenteredRow_1.CenteredRow, { className: "mt-2" },
                                "[",
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faLock, className: "mr-2" }),
                                ",",
                                react_1.default.createElement("p", { className: "mb-0 text-danger" },
                                    "Was ",
                                    (initialVersion || '?').substr(0, 20),
                                    " now is",
                                    ' ',
                                    (newVersion || '?').substr(0, 20),
                                    "."),
                                "]")))),
                ") , (",
                react_1.default.createElement(ReloadButton_1.ReloadButton, null),
                ") ]")));
    }
    // if (debug && prevContext && context.appSettings && prevContext.appSettings) {
    //   return (
    //     <>
    //       Foobar:
    //       {prevContext.appSettings.version} {context.appSettings.version}
    //     </>
    //   );
    // }
    if (debug) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null,
                "version: ",
                context.appSettings && context.appSettings.version),
            react_1.default.createElement("p", null,
                "initialVersion: ",
                initialVersion),
            react_1.default.createElement("p", null,
                "newVersion: ",
                newVersion)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
//# sourceMappingURL=OsmosysIsOutOfDateToast.js.map